import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarehouseConfigItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Item/ItemBrowser")
	}

	render() {
		return (
			<Activity 
				name="WarehouseConfigItem"
				RenderedComponent={this.RenderedComponent}
				context="WarehouseConfigItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarehouseConfigItemActivity)
